/**
 * Author: Srilal S. Siriwardhane
 * Email: SrilalS@99x.io
**/
import { CreateMLCEngine } from "@mlc-ai/web-llm";
import { AbstractLLMInferenceEngine } from "./AbstractLLMInferenceEngine.js";
import { AIChatMessage } from "../types/ChatMessages.js";
import { ModelInfo } from "../types/Model.js";
/**
 * WebLLMInferenceEngine class to handle the LLM Inference using the Web-LLM.
 * This class extends the LLMInferenceFactory to enforce the methods.
 */
export class WebLLMInferenceEngine extends AbstractLLMInferenceEngine {
    status;
    llmModel;
    engine;
    /**
     * constructor
     * @param model - The model to be used for inference. should be one of allowed models.
     * Allowed Models: 'phi', 'gemma'
     * This list of models will be updated as more models are added in the future releases.
     */
    constructor(model) {
        super();
        this.llmModel = model;
        this.status = {
            progress: 0,
            text: '[ Initializing ]',
            timeElapsed: 0
        };
    }
    static async init(model) {
        const instance = new WebLLMInferenceEngine(model);
        await instance.createEngine();
        return instance;
    }
    /**
     * createEngine
     *
     * This function is used to create the engine based on the selected model.
     *
     */
    async createEngine() {
        this.engine = await CreateMLCEngine(this.getModel(), {
            initProgressCallback: this.progressCallback.bind(this)
        });
    }
    /**
     * availableModels
     * @returns AvailableModels
     */
    availableModels = {
        'phi': new ModelInfo('Phi-3-mini-4k-instruct-q4f16_1-MLC'),
        'phi35': new ModelInfo('Phi-3.5-mini-instruct-q4f16_1-MLC'),
        'gemma': new ModelInfo('gemma-2b-it-q4f16_1-MLC'),
        'gemma2': new ModelInfo('gemma-2-2b-it-q4f16_1-MLC')
    };
    async runChatInference(chat) {
        const messages = chat;
        const reply = await this.engine.chat.completions.create({
            messages,
        });
        chat.push(new AIChatMessage(reply.choices[0].message.content));
        return chat;
    }
    runCompletionInference(prompt) {
        throw new Error("Method not implemented.");
    }
    /**
     * getModel
     * @returns string
     *
     * This function is used to get the model name based on the selected model.
     * It returns a string.
     *
     */
    getModel() {
        try {
            return this.availableModels[this.llmModel].name;
        }
        catch (error) {
            throw new Error("Model not Found or not Supported!");
        }
    }
    progressCallback(progress) { }
}
//# sourceMappingURL=WebLLMInferenceEngine.js.map